import { useState } from "react";

import { type ProspectWithMemberCount } from "../OutreachTable/hooks/useOutreachManagement";

import { ManageAccessStep } from "./ManageAccessStep";
import { NotifyUsersStep } from "./NotifyUsersStep";

type ShareModalStep = "manageAccess" | "notifyUsers";

type ShareModalProps = {
  isOpen: boolean;
  onClose: () => void;
  dealId: string;
  dealName: string;
  prospects: ProspectWithMemberCount[];
  onSuccess?: () => void;
};

export const ShareModal = ({
  isOpen,
  onClose,
  dealId,
  dealName,
  prospects,
  onSuccess,
}: ShareModalProps) => {
  const [step, setStep] = useState<ShareModalStep>("manageAccess");

  const isMultiple = prospects.length > 1;
  const firstProspect = prospects[0];

  const handleGoToEmail = () => {
    setStep("notifyUsers");
  };

  const handleBackToAccess = () => {
    setStep("manageAccess");
  };

  const handleClose = () => {
    setStep("manageAccess");
    onClose();
  };

  if (!isOpen) return null;

  if (isMultiple || step === "notifyUsers") {
    return (
      <NotifyUsersStep
        dealId={dealId}
        dealName={dealName}
        onBack={isMultiple ? handleClose : handleBackToAccess}
        onClose={handleClose}
        onSuccess={onSuccess}
        prospects={prospects}
      />
    );
  }

  return (
    <ManageAccessStep
      dealId={dealId}
      onClose={handleClose}
      onEmailOpportunity={handleGoToEmail}
      prospect={firstProspect}
    />
  );
};
